import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { deepMerge } from '../../../../../utils/object-utils';
import { getMember } from '../../../selectors/member/get-member';
import { assertIsMemberSignedIn } from '../../../utils/assert-is-member-signed-in';
export const updateMemberPersonalDetails = async (newDetails, captchaResponse) => {
    const member = getMember();
    assertIsMemberSignedIn(member, 'Cannot update member personal details');
    const mergedDetails = deepMerge(member.personalDetails, newDetails);
    await ocapiClient.instance.v1.loyalty.members.update.setPersonalDetails(mergedDetails, captchaResponse);
    runInAction(() => {
        member.personalDetails = mergedDetails;
    });
    return mergedDetails;
};
